import { render, staticRenderFns } from "./InterfaceModal.vue?vue&type=template&id=981932cc&scoped=true&"
import script from "./InterfaceModal.vue?vue&type=script&lang=js&"
export * from "./InterfaceModal.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceModal.vue?vue&type=style&index=0&id=981932cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981932cc",
  null
  
)

export default component.exports